import styled from '@emotion/styled'

export const Image = styled.img``
